/* ---------------------------------------------------------------------------
   מספר הקצאה (רפורמת החשבוניות): חשבונית מס שסכומה לפני מע"מ עולה על הסף
   צריכה מספר מרשות המסים, ובלי ח.פ/ת.ז של הלקוח הוא לא יינתן. ההקצאה עצמה
   קורית בהפקת החשבונית (חשבונית ירוקה, ADR 0004) — כאן רק מזהירים מוקדם,
   בהצעת המחיר, כדי שהפרט החסר יושלם לפני שהעבודה נגמרת.
   אותו סף כמו בשרת: src/processes/green-invoice-billing/green-invoice-document.ts.
   --------------------------------------------------------------------------- */

import type { VatMode } from './quote-discount';

/** ב-₪, לפני מע"מ. "עולה על" — 5,000 בדיוק לא חייבת. */
export const ALLOCATION_THRESHOLD = 5_000;

/**
 * להזהיר על ח.פ חסר? עוסק פטור לא מפיק חשבונית מס, ולכן אין לו מספר הקצאה.
 * `netAgorot` — הסכום אחרי הנחה ולפני מע"מ, באגורות.
 */
export function needsTaxIdForAllocation(
  netAgorot: number,
  mode: VatMode,
  taxId: string | null | undefined,
): boolean {
  if (mode === 'exempt') return false;
  if (taxId?.trim()) return false;
  return netAgorot > ALLOCATION_THRESHOLD * 100;
}
